'use client';

import * as React from 'react';
import { draggable } from '@atlaskit/pragmatic-drag-and-drop/element/adapter';
import { disableNativeDragPreview } from '@atlaskit/pragmatic-drag-and-drop/element/disable-native-drag-preview';
export function useEventResizeHandler(parameters) {
  const {
    ref,
    side,
    getDragData,
    contextValue: {
      doesEventStartBeforeCollectionStart,
      doesEventEndAfterCollectionEnd
    }
  } = parameters;
  const enabled = side === 'start' && !doesEventStartBeforeCollectionStart || side === 'end' && !doesEventEndAfterCollectionEnd;
  const state = React.useMemo(() => ({
    start: side === 'start',
    end: side === 'end'
  }), [side]);
  React.useEffect(() => {
    if (!ref.current || !enabled) {
      return undefined;
    }
    return draggable({
      element: ref.current,
      getInitialData: ({
        input
      }) => getDragData(input),
      onGenerateDragPreview: ({
        nativeSetDragImage
      }) => {
        disableNativeDragPreview({
          nativeSetDragImage
        });
      }
    });
  }, [ref, enabled, side, getDragData]);
  return {
    state,
    enabled
  };
}